<template>
  <q-input
    :aid="customAid"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :maxlength="250"
    counter
    placeholder="Description"
    autogrow
  />
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "runai-description-input",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: [String, null] as PropType<string | null>,
      required: true,
      default: null,
    },
    customAid: {
      type: String as PropType<string>,
      required: false,
    },
  },
});
</script>
